
import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx'; 
import Content from '../../components/user/sub1_3/Content.jsx'; 

import Footer from '../../components/user/footer/Footer.jsx';


import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub1_2() {  

  const introData = {
    mainTitle: "크림봇",
    subTitle: "새로운 미래로 도약해 나갑니다",
    menuItems: [
      { title: "회사소개", link: "/sub1_1", active: false },
      { title: "연혁", link: "/sub1_2", active: false },
      { title: "오시는 길", link: "/sub1_3", active: true }
    ]
  };
  
  return (
    <>
      <Header />
      <SubIntro 
        mainTitle={introData.mainTitle} 
        subTitle={introData.subTitle} 
        menuItems={introData.menuItems} 
      />
     <Content/>
      <Footer />
    </>
  );
}